import KendoMediaPlayer from '../KendoMediaPlayer'

let KendoMediaPlayerInstaller = class {
    static install(Vue) {
        Vue.component(KendoMediaPlayer.name, KendoMediaPlayer)
    }
}

export default KendoMediaPlayerInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoMediaPlayerInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-mediaplayer-vue-wrapper/src/kendo-mediaplayer-installer/index.js